import { AssetCommand, GridRequestQuery } from '@api';

export class ExecuteCommand {
    public static readonly type = '[Asset Details] Execute Command';

    constructor(public command: AssetCommand) {}
}

export class GetCommandExecutionHistorys {
    public static readonly type = '[Asset Details] Get Command Execution Historys';

    constructor(
        public deviceId: string,
        public assetId: string,
        public gridRequestQuery: GridRequestQuery = {}
    ) {}
}
